export const _exe_name = 'exe_name'
export const error = 'error'
export const Mac = 'Mac'
export const Windows = 'Windows'
export const keydown = 'keydown'
export const bypassType = 'Bypass'
export const blockType = 'Block'
export const ignoreType = 'Do Not Bypass'
export const application = 'application'
export const domain = 'domain'

export const applicationTypeArr = [bypassType, blockType]
export const applicationDefaultTypeArr = [bypassType, ignoreType]

export const ApplicationDefaultBypassList = 'applicationDefaultBypassList'
export const ApplicationIgnoreBypassList = 'applicationIgnoreBypassList'

export const DomainDefaultBypassList = 'domainDefaultBypassList'
export const DomainIgnoreBypassList = 'domainIgnoreBypassList'

export const deletedData = {name: '', type: ''}

export const DEFAULT_URL_BYPASS_COLUMNS = [
  {
    name: 'DOMAIN NAME',
    dataKey: 'domainName',
    widthPercentage: 60,
  },
  {
    name: 'TRAFFIC',
    dataKey: 'traffic',
    widthPercentage: 35,
  },
  {name: '', dataKey: 'rightArrow', widthPercentage: 5},
]

export const CUSTOM_URL_BYPASS_COLUMNS = [
  {
    name: 'DOMAIN NAME',
    dataKey: 'domainName',
    widthPercentage: 32,
  },
  {name: 'Note', dataKey: 'note', widthPercentage: 27},
  {name: 'Updated By', dataKey: 'updatedBy', widthPercentage: 16},
  {name: 'Updated At', dataKey: 'updatedAt', widthPercentage: 15},
  {name: '', dataKey: 'rightArrow', widthPercentage: 10},
]

export const DEFAULT_APP_BYPASS_COLUMNS = [
  {
    name: 'PROCESS EXECUTABLE NAME',
    dataKey: 'processExecutableName',
    widthPercentage: 40,
  },
  {
    name: 'OS',
    dataKey: 'os',
    widthPercentage: 20,
  },
  {name: 'Traffic', dataKey: 'traffic', widthPercentage: 35},
  {name: '', dataKey: 'rightArrow', widthPercentage: 5},
]

export const CUSTOM_APP_BYPASS_COLUMNS = [
  {
    name: 'PROCESS EXECUTABLE NAME',
    dataKey: 'processExecutableName',
    widthPercentage: 32,
  },
  {name: 'Note', dataKey: 'notes', widthPercentage: 27},
  {
    name: 'OS',
    dataKey: 'os',
    widthPercentage: 10,
  },
  {name: 'Updated By', dataKey: 'updatedBy', widthPercentage: 11},
  {name: 'Updated At', dataKey: 'updatedAt', widthPercentage: 11},
  {name: '', dataKey: 'rightArrow', widthPercentage: 9},
]
